import React, { useRef, useState } from 'react';
import './ImageCarousel.css';

interface ImageCarouselProps {
  images: string[];
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [zoomImage, setZoomImage] = useState<string | null>(null);

  const goToPrevious = () => {
    const isFirstImage = currentIndex === 0;
    const newIndex = isFirstImage ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const goToNext = () => {
    const isLastImage = currentIndex === images.length - 1;
    const newIndex = isLastImage ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  return (
    <div className="carousel_wrapper">
      {/* Main Image Display */}
      <div className="main_image_container">
        <button 
          className="carousel_arrow left" 
          onClick={goToPrevious}
          aria-label="Previous image"
        >
          ←
        </button>
        
        <img
          src={images[currentIndex]}
          alt={`Product ${currentIndex + 1}`}
          className="main_image"
          onClick={() => setZoomImage(images[currentIndex])}
        />
        
        <button 
          className="carousel_arrow right" 
          onClick={goToNext}
          aria-label="Next image"
        >
          →
        </button>
      </div>

      {/* Thumbnail Strip */}
      <div className="thumbnails_container">
        {images.map((img, index) => (
          <div 
            key={index} 
            className={`thumbnail_wrapper ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          >
            <img
              src={img}
              alt={`Thumbnail ${index + 1}`}
              className="thumbnail_image"
            />
          </div>
        ))}
      </div>

      {/* Zoom Preview */}
      {zoomImage && (
        <div className="zoom_overlay" onClick={() => setZoomImage(null)}>
          <img src={zoomImage} className="zoomed_image" alt="Zoomed" />
        </div>
      )}
    </div>
  );
};

export default ImageCarousel;